<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/angie_cooke.jpg" alt="Angie Cooke">
          </figure>
        <div class="finger-print"><img  src="@/assets/images/fingerprints/fingerprint-fourteen.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Angie Cooke</h2>

      <p class="job-title"> Research Project Coordinator</p>


     
      <p class="profile-statement-interviewer">Tell us a little bit about yourself</p>

      <p>I’m Angie, and my ethnic heritage is Aruban and Grenadian. I’m originally from Huddersfield, and I’ve lived in Manchester since I left home aged 20 to attend university at Salford and Bolton. I have a degree in Business Administration. I love music (especially by Manchester bands from the 1970s-90s), vegan food, and finding bargains in vintage emporiums and charity shops.</p>

      <p class="profile-statement-interviewer">What inspires you within your role?</p>

      <p>I’m a member of the Equality, Diversity and Inclusion Working Group for my directorate, and I hope to be able to inspire my colleagues by demonstrating that as a member of the black community I’m not a mere stereotype, and also help to bring about change.</p>

      <p class="profile-statement-interviewer">What is something that you love about your culture or heritage?</p>

      <p>How quietly determined, dignified and noble the Afro Caribbean community is, particularly in the face of great adversity, severe disadvantage and micro-aggressions on a daily basis.</p>

      <p class="profile-statement-interviewer">What does it look like to bring your whole self to your work?</p>

      <p>It seems like such a little thing but it makes a big difference, which is being able to have my hair in its natural form (I have what I call an Afro Quiff). I stopped using chemical straighteners many years ago. My hair style should not be judged as a reflection of my capability or professionalism in the workplace.</p>

      <p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students? </p>

      <p>Doing more to ensure that the university’s Black, Asian, and Ethnic Minority population is considered equally and fairly in comparison to traditionally more advantaged and therefore higher achieving groups when it comes recruitment, retention and progression (staff), and grading of degrees at a higher level (students).</p>

      <p class="profile-statement-interviewer">What are you most proud of?</p>

      <p>How far I’ve come personally, despite being dismissed and written off from a very early age.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  .profile-container {
  flex-direction: row-reverse;
  }

  .profile-portrait-container {
    justify-content: flex-end;

    & figure {
      text-align: right;
    }
  }

  // .profile-statement {
  //   padding-right: 5rem;
  //   // padding-left: 5rem;
  // }


</style>